
import React from 'react'
import EmptyPage from './EmptyPage'
import { Body1 } from './typography'

const NotFound = () => (
  <EmptyPage
    title='Not Found'
    buttonHref='/workspaces'
    buttonText='Go to my workspaces'
    rel='external'
    body={(
      <Body1>
        Sorry, we could not find what you were looking for!
      </Body1>
    )} />
)

NotFound.displayName = 'NotFound'

export default NotFound



// WEBPACK FOOTER //
// ./ui/NotFound.js